module.exports = __webpack_public_path__ + "img/session-sign-up-bg.55db32cc.jpg";